/* eslint-disable max-len */
import 'react';

const ClockSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path id="ClockSvg_prefix__a" d="M0 0h12v12H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="ClockSvg_prefix__b" fill="#fff">
                <use xlinkHref="#ClockSvg_prefix__a" />
            </mask>
            <path
                d="M6 .4a5.6 5.6 0 100 11.2A5.6 5.6 0 006 .4zm0 1.2a4.4 4.4 0 110 8.8 4.4 4.4 0 010-8.8z"
                fill="#878D99"
                fillRule="nonzero"
                mask="url(#ClockSvg_prefix__b)"
            />
            <path
                d="M5.678 3.682a.6.6 0 01.593.502l.007.098v1.854h1.394a.6.6 0 01.592.503l.008.098a.6.6 0 01-.502.592l-.098.008H5.678a.6.6 0 01-.592-.503l-.008-.097V4.282a.6.6 0 01.6-.6z"
                fill="#878D99"
                fillRule="nonzero"
                mask="url(#ClockSvg_prefix__b)"
            />
        </g>
    </svg>
);
export default ClockSvg;
